import React, { Component } from 'react';
import { connect } from 'react-redux';
import GenericTable from 'screens/components/advanced/GenericTable';

class POPrintToPDF extends Component {
    constructor() {
        super();

    }

    poProductList = (products) => {
        let list = [];
        products.map((product) => {
            list.push(
                {
                    SKU: product.sku,
                    Product: <div className="text-left">{product.product}</div>,
                    ActualQuantity: product.actualQuantity != null ? product.actualQuantity : 0,
                    Quantity: product.quantity,
                    UnitPrice: "$" + product.unitPrice.toFixed(2),
                    Price: "$" + product.price
                });
        });

        return list;
    }

    render() {
        const tableColumns = [
            { key: "SKU", label: "SKU", width: "120px" },
            { key: "Product", label: "Product", width: "40%" },
            { key: "ActualQuantity", label: "Current Qty" },
            { key: "Quantity", label: "Ordred Qty" },
            { key: "UnitPrice", label: "Unit Cost" },
            { key: "Price", label: "Total" }
        ]

        const p = this.props;

        return (p.po ?
            <div id={p.name} className="visuallyhidden mb-2" style={{}}>
                <div className="printable p-3">
                    <div className="row m-2">
                        <h2 className="col-lg-12"><b>Purchase Order</b></h2>
                    </div>
                    <div className="row m-2">
                        <table className="w-100">
                            <tr>
                                <td className="text-left"><b>Purchase Order Number</b>&nbsp; {p.po.id}</td>
                                <td className="text-left"><b>Payment Due Date</b>&nbsp; {p.po.paymentDueDate.slice(0, 10)}</td>
                            </tr>

                            <tr>
                                <td className="text-left"><b>Purchase Order Date</b>&nbsp; {p.po.creationDateString}</td>
                                <td className="text-left"><b>Date Expected</b>&nbsp; {p.po.dateExpected.slice(0, 10)}</td>
                            </tr>

                            <tr>
                                <td className="text-left"><b>Purchase Order Status</b>&nbsp; {p.po.status}</td>
                                <td className="text-left">&nbsp;</td>
                            </tr>
                            <tr>
                                <td className="text-left">
                                    <div><b>Supplier Information</b></div>
                                    <div>{p.po.vendor}</div>
                                    <div>&nbsp;</div>
                                    <div>&nbsp;</div>
                                    <div>&nbsp;</div>
                                </td>
                                <td className="text-left">
                                    <div><b>Store Information</b></div>
                                    <div>{p.store.name}</div>
                                    <div>{p.store.phone}</div>
                                    <div>{p.store.street}, {p.store.city}, {p.store.provinceState}</div>
                                    <div>{p.store.postalCode}</div>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <GenericTable
                                columns={tableColumns}
                                rows={this.poProductList(p.po.products)}
                            />
                        </div>
                    </div>
                    <div className="row pr-2 mt-2">
                        <table className="w-100 p-0">
                            <tr className="p-0 m-0">
                                <td className="text-right w-80"><b>Sub Total</b></td>
                                <td className="text-right">$ {p.po.subTotal}</td>
                            </tr>
                            {p.po.delieveryFee > 0 &&
                                <tr>
                                    <td className="text-right w-80"><b>Shipping Cost</b></td>
                                    <td className="text-right">$ {p.po.delieveryFee}</td>
                                </tr>}
                            {p.po.recycleFee > 0 &&
                                <tr>
                                    <td className="text-right w-80"><b>Recycle Fee</b></td>
                                    <td className="text-right">$ {p.po.recycleFee}</td>
                                </tr>}
                            {p.po.totalDepositAmount > 0 &&
                                <tr>
                                    <td className="text-right w-80"><b>Deposit Amount</b></td>
                                    <td className="text-right">$ {p.po.totalDepositAmount}</td>
                                </tr>}
                            {p.po.taxes && p.po.taxes.map((tax, index) => tax.amount > 0 ?
                                <tr key={index}>
                                    <td className="text-right w-80"><b>{tax.name}</b></td>
                                    <td className="text-right">$ {tax.amount}</td>
                                </tr> : null)}
                            <tr>
                                <td className="text-right w-80"><b>Total</b></td>
                                <td className="text-right">$ {p.po.total}</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </div>
            : null)
    }
}

function mapStateToProps(state) {
    return {
        po: state.entity.purchaseOrder,
        store: state.common.store
    }
}

export default connect(mapStateToProps)(POPrintToPDF);
